<div class="p-4">
  <div class="container">
    <h1>{{ 'Dash' | translate }}</h1>
  </div>
</div>
